// import React from 'react';
// import Plot from 'react-plotly.js';

// const TreemapChart = () => {
//   const labels = ["Pack", "Module 1", "Module 2", "mX", "mA", "mY", "mB", "mZ", "SANKALP"];
//   const parents = ["", "Pack", "Pack", "Module 1", "Module 2", "Module 1", "Module 2", "Module 1", "Module 2"];

//   // Define values for the size of each square
//   const sizeValues = [10, 10, 10, 10, 4, 9, 10, 10, 10]; // Change these values as needed

//   // Define values for the color of each square
//   const colorValues = [0.10, 0.20, 0.56, 0.23, 0.89, 3, 7, 1, 10.4]; // Change these values as needed
//   const normalizedColorValues = colorValues.map(value => (value - Math.min(...colorValues)) / (Math.max(...colorValues) - Math.min(...colorValues)));
//   // Custom color scale based on the provided colors
//   const customColorscale = [
//     [0, '#00008b'], // Low value color
//     [1, '#e73027']  // High value color
//   ];

//   const data = [{
//     type: "treemap",
//     labels: labels,
//     parents: parents,
//     values: sizeValues, // Use the sizeValues array here for size
//     textinfo: "label+value+percent parent+percent entry",
//     domain: { "x": [0, 1] },
//     outsidetextfont: { "size": 10, "color": "#377eb8" },
//     marker: {
//       // "line": { "width": 2 },
//       // colorscale: customColorscale,
//       colorscale: 'thermal',
//       // Assign color based on colorValues array
//       color: colorValues,
//       colorbar: {
//         title: 'Color Scale'
//       }
//     },
//     pathbar: { "visible": true }
//   }];
//   // var layout = { treemapcolorway: ["pink", "lightgray"] }
//   return (
//     <Plot
//       data={data}
//       // layout={layout}
//       style={{ width: '100%', height: '100%' }}
//     />
//   );
// };

// export default TreemapChart;
